import DeviationMediaService from '../utils/DeviationMediaService';
import MonoView from './MonoView';
import GalleryView from './GalleryView';
import EmoteSelectorNg from '../EmoteSelectorNg';
import InlineView from './InlineView';
export const externalRenderers = {
    deviation: MonoView,
    gallery: GalleryView,
    mediaService: DeviationMediaService,
    emoteSelector: EmoteSelectorNg,
    inline: InlineView
};

//# sourceMappingURL=config.js.map